import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { createConfig, getConfig, updateConfig } from '@/apis/config'
import useNotification from '@/hooks/useNotification'
import { CreateConfigTimeWorkRequest, UpdateConfigTimeWorkRequest } from '@/types/apis/config'
import { TimeWork } from '@/types/apis/config/GetConfigTimeWorkResponse'

export const useConfig = () => {
  const { t } = useTranslation()
  const openNotification = useNotification()

  const [getConfigResponse, setConfigResponse] = useState<TimeWork>()
  const [loading, setLoading] = useState(false)

  const getConfigTime = useCallback(async () => {
    try {
      setLoading(true)
      const res = await getConfig()
      setConfigResponse(res)
    } catch (err) {
      // ignore
    } finally {
      setLoading(false)
    }
  }, [])

  const createConfigTime = useCallback(
    async (request: CreateConfigTimeWorkRequest) => {
      try {
        await createConfig(request)
        openNotification({ description: t('pages.config.create') })
      } catch (err) {
        openNotification({ type: 'error', description: t('pages.config.createFail') })
        // ignore
      }
    },
    [openNotification, t]
  )

  const updateConfigTime = useCallback(
    async (request: UpdateConfigTimeWorkRequest) => {
      try {
        await updateConfig(request)
        openNotification({ description: t('pages.config.update') })
      } catch (err) {
        openNotification({ type: 'error', description: t('pages.config.updateFail') })
        // ignore
      }
    },
    [openNotification, t]
  )

  return {
    getConfigTime,
    getConfigResponse,
    createConfigTime,
    updateConfigTime,
    loading,
  }
}
